import React from "react";
import NavIconWrapper from "./NavIconWrapper";
import { Typography } from "clearsense-ui/components";
import { motion } from "framer-motion";
import { RightMinimalArrow } from "icons";
import classNames from "classnames";

const Item = ({
  icon,
  collapsed,
  haveNestedItems,
  isOpen,
  mainLabel,
  className,
  showIcon = true,
}) => {
  const IconSVG = icon;
  return (
    <>
      {((icon && showIcon) || collapsed) && (
        <NavIconWrapper collapsed={collapsed} mainLabel={mainLabel}>
          <div className="flex items-center justify-center cs-ui-sidebar__link-icon">
            <IconSVG />
          </div>
        </NavIconWrapper>
      )}
      {!collapsed && (
        <>
          <Typography
            component="span"
            style="medium"
            className={classNames("font-medium", { [className]: className })}
          >
            {mainLabel}
          </Typography>
          {haveNestedItems && (
            <motion.div
              variants={{
                open: { rotate: 90 },
                collapsed: { rotate: 0 },
              }}
              animate={isOpen[mainLabel] ? "open" : "collapsed"}
              transition={{ duration: 0.3 }}
              className="flex-grow-0 cs-ui-accordion__item-toggle-icon"
            >
              <RightMinimalArrow size={16} color="#68737D" />
            </motion.div>
          )}
        </>
      )}
    </>
  );
};

export default Item;
